import { useEffect, useState } from "react";
import "./index.scss";

interface ToggleProps {
  label?: string;
  checked?: boolean;
  onChange?: (value: boolean) => void;
}

export function Toggle({ label, checked = false, onChange }: ToggleProps) {
  const [isChecked, setIsChecked] = useState(checked);

  const handleToggle = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange?.(newValue);
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <div className="custom-toggle-container" onClick={handleToggle}>
      <div className={`custom-toggle ${isChecked ? "checked" : ""}`}>
        <div className="toggle-circle" />
      </div>

      {label && <span className="toggle-label">{label}</span>}
    </div>
  );
}
